// Event constructor polyfill for IE11
import 'events-polyfill/src/constructors/Event'

// IntersectionObserver polyfill for chrome < 51, IE 11
import "intersection-observer";

// polyfill for Chrome < 49
import URLSearchParams from 'core-js/features/url-search-params';
window.URLSearchParams = URLSearchParams;

// polyfill for older MIUI browsers and others who don't implement Crypto#getRandomValues
// the polyfill library is a simple Mersenne twister wrapper, should be timeless
const isCryptoAPIImplemented = typeof crypto != 'undefined' && crypto.getRandomValues && crypto.getRandomValues.bind(crypto)
if (! isCryptoAPIImplemented) {
  window.crypto = { getRandomValues: require('polyfill-crypto.getrandomvalues') }
}

// String#includes polyfill for Chrome < 41 and IE 11
if (!String.prototype.includes) {
  String.prototype.includes = function(search, start) {
    'use strict';

    if (search instanceof RegExp) {
      throw TypeError('first argument must not be a RegExp');
    }
    if (start === undefined) { start = 0; }
    return this.indexOf(search, start) !== -1;
  };
}

// NodeList forEach polyfill for Chrome < 51
if (window.NodeList && !NodeList.prototype.forEach) {
    NodeList.prototype.forEach = function (callback, thisArg) {
        thisArg = thisArg || window;
        for (var i = 0; i < this.length; i++) {
            callback.call(thisArg, this[i], i, this);
        }
    };
}

// getComputedStyle polyfill for Firefox < 62
// replacing `null` output with empty object
if(/firefox/i.test(navigator.userAgent)){
  var oldGetComputedStyle = window.getComputedStyle;
  window.getComputedStyle = function(el, pseudoElt){
    var result = oldGetComputedStyle(el, pseudoElt);
    if(result === null){
      return {};
    }else{
      return result;
    }
  };
}

// Object#assign polyfill for Chrome < 41 and IE
// https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Object/assign#Polyfill
if (typeof Object.assign !== 'function') {
  // Must be writable: true, enumerable: false, configurable: true
  Object.defineProperty(Object, "assign", {
    value: function assign(target) { // .length of function is 2
      'use strict';
      if (target === null || target === undefined) {
        throw new TypeError('Cannot convert undefined or null to object');
      }

      var to = Object(target);

      for (var index = 1; index < arguments.length; index++) {
        var nextSource = arguments[index];

        if (nextSource !== null && nextSource !== undefined) {
          for (var nextKey in nextSource) {
            // Avoid bugs when hasOwnProperty is shadowed
            if (Object.prototype.hasOwnProperty.call(nextSource, nextKey)) {
              to[nextKey] = nextSource[nextKey];
            }
          }
        }
      }
      return to;
    },
    writable: true,
    configurable: true
  });
}

// String#starts_with polyfill for IE11, Chrome < 41
if (!String.prototype.startsWith) {
  Object.defineProperty(String.prototype, 'startsWith', {
    value: function(search, rawPos) {
        var pos = rawPos > 0 ? rawPos|0 : 0;
        return this.substring(pos, pos + search.length) === search;
    }
  });
}
